<template>
  <div>
    <div class="main-search search-container" data-search-page="/Corporate/Search">
      <input type="text" id="query-input" :placeholder="labels.searchPlaceholder" v-model="query" @keyup="onKeyUp"
        aria-labelledby="query-input" />
      <a class="icon-link icon-link-clear" @click="clearQuery"></a>
      <div class="vertical-separator"></div>
      <a class="icon-link icon-link-search" @click="performSearch"><span>{{ labels.searchButton }}</span></a>
    </div>
    <PromotedResult v-if="showPromotedResults"></PromotedResult>
    <TabBox :initial-tab="currentTab" :result-counts="results">
      <Tab :label="labels.tabNames.products" internal-name="products" :selected="currentTab === 'products'"
        v-if="hiddenTabs.indexOf('products') === -1">
        <ProductSearch v-model="results.products" />
      </Tab>
      <Tab :label="labels.tabNames.pages" internal-name="pages" :selected="currentTab === 'pages'"
        v-if="hiddenTabs.indexOf('pages') === -1">
        <PageSearch v-model="results.pages" />
      </Tab>
      <Tab :label="labels.tabNames.downloads" internal-name="downloads" :selected="currentTab === 'downloads'"
        v-if="hiddenTabs.indexOf('downloads') === -1">
        <DownloadSearch v-model="results.downloads" />
      </Tab>
      <Tab :label="labels.tabNames.sds" internal-name="sds" :selected="currentTab === 'sds'"
        v-if="hiddenTabs.indexOf('sds') === -1">
        <SDSSearch v-model="results.sds" />
      </Tab>
      <Tab :label="labels.tabNames.news" internal-name="news" :selected="currentTab === 'news'"
        v-if="hiddenTabs.indexOf('news') === -1">
        <NewsSearch v-model="results.news" />
      </Tab>
      <Tab :label="labels.tabNames.events" internal-name="events" :selected="currentTab === 'events'"
        v-if="hiddenTabs.indexOf('events') === -1">
        <EventSearch v-model="results.events" />
      </Tab>
    </TabBox>
  </div>
</template>

<script>
import TabBox from "./components/ui/TabBox.vue";
import Tab from "./components/ui/Tab.vue";
import ProductSearch from "./components/ProductSearch.vue";
import NewsSearch from "./components/NewsSearch.vue";
import EventSearch from "./components/EventSearch.vue";
import DownloadSearch from "./components/DownloadSearch.vue";
import SDSSearch from "./components/SDSSearch.vue";
import PageSearch from "./components/PageSearch.vue";
import PromotedResult from "./components/PromotedResult.vue";
import { Bus } from "./components/services/bus.js";
import { Labels } from "./components/services/labels.js";
import { Settings } from "./components/services/settings.js";
import { Polyfills } from "./components/services/polyfills.js";
import { SessionState } from "./components/services/session-state.js";

export default {
  name: "searchApp",
  components: {
    TabBox,
    Tab,
    ProductSearch,
    NewsSearch,
    EventSearch,
    DownloadSearch,
    SDSSearch,
    PageSearch,
    PromotedResult,
  },
  data() {
    return {
      wsUrl: "",
      labels: Labels,
      results: {
        products: 0,
        news: 0,
        events: 0,
        downloads: 0,
        pages: 0,
        sds: 0,
      },
      query: "",
      currentTab: SessionState.get("app", "tab") || "products",
      tags: "",
      fixedTags: "",
      hiddenTabs: "",
      tabCount: 5,
      showPromotedResults: Settings.showPromotedResults,
    };
  },
  created() {
    var oThis = this;
    Polyfills.init();
    Labels.init();
    Settings.init();

    this.query = "";
    this.currentTab = SessionState.get("app", "tab") || "products";
    if (Settings.hiddenTabs.indexOf(this.currentTab) !== -1)
      this.currentTab = Settings.getFirstVisibleTab();
    var params = window.location.href.substring(
      window.location.href.indexOf("?") + 1
    );
    if (params.length > 0) {
      params.split("&").forEach(function (item) {
        var pair = item.split("=");
        if (pair.length == 2) {
          var key = pair[0].toLowerCase();
          if (key == "q") {
            oThis.query = decodeURIComponent(pair[1]);
          } else if (key == "tab") {
            oThis.currentTab = pair[1];
          } else if (key == "tag") {
            if (oThis.tags.length > 0) oThis.tags += ",";
            oThis.tags += pair[1];
          } else if (Settings.fixedQueryFilters.hasOwnProperty(key)) {
            Settings.fixedQueryFilters[key].push(pair[1]);
          }
        }
      });
      oThis.fixedTags = oThis.tags;
    }

    // Pigments finder specific
    this.hiddenTabs = Settings.hiddenTabs;
    this.tabCount = this.hiddenTabs
      ? 5 - (this.hiddenTabs.match(/,/g) || []).length
      : 5;
    //
    var prevQuery = SessionState.get("app", "urlquery");
    var prevTags = SessionState.get("app", "tags");
    SessionState.set("app", "urlquery", this.query);
    if (
      (prevQuery != null && prevQuery !== this.query) ||
      (prevTags != null && prevTags != this.tags)
    ) {
      console.log(
        "The query and tags are different than those of the last search. Clearing session state."
      );
      //oThis.currentTab = "products";
      SessionState.clear();
    } else {
      console.log(
        "The query and tags are the same as those of the last search. Applying session state."
      );
      var oldquery = SessionState.get("app", "query");
      if (oldquery != null) this.query = oldquery; //we override the query, if the url has not changed
    }

    this.showPromotedResults = Settings.showPromotedResults;

    document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", () => {
      this.waitForDOM();
    }) : this.waitForDOM();

    setTimeout(function () { });
  },
  methods: {
    waitForDOM() {
      let oThis = this;

      waitForAssetManager(() => {
        window.cla.assetManager.loadStylesheet(
          "/styles/components/flat-tab-box.css"
        );
        window.cla.assetManager.loadScript(
          "/scripts/components/flat-tab-box.js",
          () => {
            oThis.$nextTick(() => {
              oThis.triggerSearch(oThis.query, oThis.tags);
            });
          }
        );
      });
    },
    triggerSearch(query, tags) {
      SessionState.set("app", "query", query);
      SessionState.set("app", "tags", tags);
      Bus.$emit("start-search", { query: query, tags: tags });
    },
    performSearch() {
      //we only do the tag pre-filtering when loading the search page.
      this.triggerSearch(this.query, this.fixedTags);
    },
    onKeyUp(event) {
      event.preventDefault();
      if (event.key == "Enter") {
        console.log("Starting search...");
        this.performSearch();
      }
    },
    clearQuery() {
      this.query = "";
      var el = document.getElementById("query-input");
      if (el) el.focus();
    },
  },
};
</script>

<style>
.cla-messagebox {
  position: fixed;
  top: 100px;
  right: 0;
  background-color: #ffffff;
  max-width: 400px;
  padding: 20px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  box-shadow: 3px 3px rgba(200, 200, 200, 0.4);
  border-left: 1px solid #e4e4e4;
  animation: slide 0.5s forwards;
  transition: opacity 500ms linear;
  opacity: 1;
  z-index: 10001;
}

@keyframes slide {
  0% {
    right: 0;
  }

  100% {
    right: 100px;
  }
}

.cla-messagebox.green {
  border-top: 3px solid green;
}

.cla-messagebox.yellow {
  border-top: 3px solid yellow;
}

.cla-messagebox.red {
  border-top: 3px solid red;
}

.search-container {
  max-width: 600px;
  background-color: #e4e4e4;
  padding: 4px 16px;
  box-sizing: border-box;
  display: flex;
  margin: 60px auto 60px;
}

.vertical-separator {
  width: 1px;
  background-color: black;
}

.search-container input {
  border: none;
  flex-grow: 1;
  background-color: #e4e4e4;
  font-size: 16px;
  line-height: normal;
}

.search-container input::-webkit-search-cancel-button {
  position: relative;
  right: 20px;
}

.search-container input::-ms-clear {
  display: none;
}

.search-container .icon-link.icon-link-search {
  background-size: 24px 24px;
  background-position-y: 50%;
  background-position-x: 10px;
  padding: 12px 10px 12px 34px;
}

.search-container .icon-link.icon-link-clear {
  padding: 12px 10px 12px 34px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  background-position-y: 50%;
  background-position-x: 10px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 14px;
  color: black;
  font-weight: 700;
}

.icon-link-search {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAAx1JREFUaAXtmDuOFDEQhhdESAAxxBAQkhFwDsjhCiDtsrscADIOA0KMhgiuABIHIIZog4H6RP+9nvKr29s9o0FdkmW7Hn+Vq93Vdh8dDaA/pkPboohxfUtcmUTWFX0n3ti8CNELFdUth7DrKRGvA6fE0wcZ8PthShjxrvXq/waRgrG9jjNJT1NAac39cm+Ye2JVe1cLxy+M+cOc0UcTPEsIPUiv8s1G9/vZ5SBrgIoXfjfe+0vbeLTqjDAMW6xZ4MiwoBKLmoyOY5xD4dyzQNkEv6zxbF9YuzL5PfvcEG9aY+PgTEnmMY8mQARQMn48UC/CIBU4IOIaDQkkwiDHGJKKGjU5AJQ6IWNS4Yl3UHIvGzWntggo7D90KCEvC9xUwh0ajkRT4Akr6rWiA37tozUtjCkywJtNFaWE8HZTXSeh8G3W9lO/MQ9U3GaiDAuMqKmwFD/Ktvj0TU7C8pA7oq47R6xkNCnCVJELwaSXOr2EetFYhpHAMThHoTukrG+ZDnXAM0GX3VUkXQmKSgnhnY73MyErsoaugNSg+7KIlhB+6gx5uXKkCwcOmkirSDlhd0n+pgndjG4HIALz/UWn89r6ZlK6PPijDlH882YPFUOA5eS0otssPgucvGpGqRgSvVZyUtFtFhO9nDSD1Axni77meJEvGVgyMDYDHJxydVy1IuzRxWavxBduZS0MrGUMBlg7pdQhm7MA3/4aoRNeqbXo6u+6GvBQud8qBJ47b5cwsfELAXtW0h8RZY1z4lVJZ01hTvJnKxcU2ZYj+tGXjARw+KMLzNSxNGHWxuJOES5gyM+vmifdV4T7u2ZQk5fuNV+d8RM3b5k+dUZf3HzSqX/cZG1I5ckFga0yr/5BTnkqPh+gjXO8tvmYSoTuZ4cBpi4vNpyX+M+xsqashT1VhYs+T4v9TWMMz1cc2V2Y7K61nRML4QPkn4gCK/XYvLVG4F7v3Hh7ITJNHSfTlEOqFlXlhzV4/FdI7XEC9otgfmbtoIiAUws5PahVWLAEnFrIbPf4uRIUXt3DBZ3M5XAuXALWAo7ncrLgLhn4XzLwF/SxQVh5o+YKAAAAAElFTkSuQmCC");
}

.icon-link-clear {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAAdFJREFUaAXtWMtOxDAMrBDfCF/IgW/kADtsZ+tWdmLXrrQC50ASx56ZOK+yy5Ip32sw6x3W0KgO7sJznTct3G/UovM2bdLQpNl3bHBwOSJKOrqQd1Rr51Mz/gXbx20SX8pEhplCgAzieig4m4lBLmeGwVky0b68PFpbA87va1cN2lzvm0weAMqTPo/2660lnTkwZaFj1/MMYCt6CxYDixIqWC1zQ61IvC1Cu/SoQiMqAbaIoDal+AiMvlSszUiLcdkkMNqypIhGwJIE7RTREaz7nYH/lAHrPbRyELnafzEiFxpPcojEe1UQHHW4zEhS4FRjkZSAWySl4BoJNsCpnBPMqqm8/LkEIcFZl5IQFDWKtfD30eDfIzjDS0gs8BKSGXiaBP/7MecEs2qmK/xtagG2vTPQGegMdAaeNQO46vFE8IsFT0BVARbfN3Bc8qxIEkyiYiJXYE6TWkFagTEVOnM4I+JMzExHetwjyuOTFpIFsETycFadm6zOabw2kYoDPyWucLDEP332NeHYOrCPxiqSlsKIiIv4pkR5gjNiMrEebUOfSvJKrKFoDuInOB7GyltFm0jo5z4K9NT4yAI4SKsLMIF9yYdctdjG6wx0Booy8AOlVApM/mLi5AAAAABJRU5ErkJggg==");
}

.icon-link {
  padding: 12px 10px 12px 34px;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  background-position-y: 50%;
  background-position-x: 10px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 14px;
  color: black;
  font-weight: 700;
  cursor: pointer;
}

a.icon-link span {
  margin-left: 5px;
}

.filter-option>.tooltip {
  height: 25px;
  margin: 0px !important;
  background-repeat: no-repeat;
}

.filter-option>.tooltip>.content {
  right: 10px;
}

@media all and (max-width: 480px) {
  .search-container {
    width: 100%;
    padding-right: 0;
  }

  .search-container .icon-link span {
    display: none;
  }

  .filter-option>.tooltip {
    height: 25px;
    margin: 0px !important;
    position: relative !important;
  }

  .filter-option>.tooltip>.content {
    left: calc(-70vw) !important;
  }
}
</style>
